<script lang="ts">
  import { Progress } from 'spaper'
</script>

<Progress {...$$restProps} infinite striped type="secondary" />
